import { z } from 'zod';
import {
  PaginationDefaults,
  PaginationQueryParamsSchema,
  PaginationResponseSchema,
} from '@terra/shared-dto-types';
import { WizSelectableObjectSchema } from './wiz-application-mapping.schema';

export const WizMappingSuggestionSchema = z.object({
  applicationId: z.string().min(1),
  object: WizSelectableObjectSchema,
  matchedRepositoryFullName: z.string().min(1),
});

export const WizMappingSuggestionsQuerySchema =
  PaginationQueryParamsSchema.extend({
    limit: z.coerce
      .number()
      .prefault(PaginationDefaults.LIMIT)
      .optional()
      .refine(
        (value) =>
          value === undefined ||
          (value >= 1 && value <= PaginationDefaults.MAX_LIMIT),
        {
          message: `limit must be between 1 and ${PaginationDefaults.MAX_LIMIT}`,
        },
      ),
  });

export const WizMappingSuggestionsResponseSchema =
  PaginationResponseSchema.extend({
    suggestions: z.array(WizMappingSuggestionSchema),
    total: z.number().int().nonnegative(),
    skip: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
  });

export type WizMappingSuggestion = z.infer<typeof WizMappingSuggestionSchema>;
export type WizMappingSuggestionsQuery = z.infer<
  typeof WizMappingSuggestionsQuerySchema
>;
